module.exports = "\n<div id=\"search-box\">\n  <!-- SearchBox widget will appear here -->\n</div>\n<div id=\"hits\">\n  <!-- Hits widget will appear here -->\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search.component.html
// module id = ./src/app/search/search.component.html
// module chunks = main